import InformationModal from 'shared/components/modal/informationModal';
import TableComponent from 'shared/components/table/table';
import TableHeader from 'shared/components/table/tableHeader';
import TableBody from 'shared/components/table/tableBody';
import TableRow from 'shared/components/table/tableRow';
import TableCell from 'shared/components/table/tableCell';
import { RightIcon } from 'shared/icon';

const CONTRACT_HEADERS = [
	{
		title: 'Contract type',
		key: 'contractType',
		tooltip: false
	},
	{
		title: 'Equipment',
		key: 'equipment',
		tooltip: true,
		tooltipText: 'Provide YONEX products.But there is a limited amount of items we can give'
	},
	{
		title: 'Annual Retainer',
		key: 'annualRetainer',
		tooltip: true,
		tooltipText: 'Two types of annual retainer \n 1: Fixed Amount  \n 2: Fluctuating Amount'
	},
	{
		title: 'Bonus',
		key: 'bonus',
		tooltip: true,
		tooltipText:
			'Additional payment based on the result and performance of their tournament, and ranking(explained below)'
	},
	{
		title: 'Reduction',
		key: 'reduction',
		tooltip: true,
		tooltipText: 'Provide YONEX products. But there is a limited amount of items we can give'
	}
];

const CONTRACT_DATA = [
	{ contractType: 'Type A', equipment: true },
	{ contractType: 'Type B', equipment: true, annualRetainer: true },
	{ contractType: 'Type C', equipment: true, annualRetainer: true, reduction: true },
	{ contractType: 'Type D', equipment: true, bonus: true },
	{ contractType: 'Type E', equipment: true, annualRetainer: true, bonus: true, reduction: true },
	{ contractType: 'Type F', equipment: true, annualRetainer: true, bonus: true }
];

export default function ContractTypeInfo({ show, onClose }: { show: boolean; onClose: () => void }) {
	return (
		<InformationModal headerTile='Contract Type' subHederTitle='' show={show} onClose={onClose} size='4xl'>
			<TableComponent className='rounded-xl border'>
				<TableHeader
					tableCellList={CONTRACT_HEADERS}
					className='sticky top-0 z-[1] table w-full table-fixed bg-white text-xs'
					headerTitleClassName='!text-wrap text-xs'
				/>

				<TableBody className='custom-scrollbar block overflow-y-auto border-none'>
					{CONTRACT_DATA.map((row: any, rowIndex) => (
						<TableRow key={rowIndex} className='table w-full table-fixed'>
							{CONTRACT_HEADERS.map((header) => (
								<TableCell key={header.key} className='border-b px-4 py-3 text-center align-middle'>
									<div className='flex items-center justify-center text-xs font-medium text-[#344054]'>
										{header.key === 'contractType' ? (
											<span>{row[header.key]}</span>
										) : (
											row[header.key] && <RightIcon height='16px' width='16px' stroke='#1D9533' />
										)}
									</div>
								</TableCell>
							))}
						</TableRow>
					))}
				</TableBody>
			</TableComponent>
		</InformationModal>
	);
}
